import React, { useState } from "react";
import { Modal, Input, Button, message } from "antd";
import "./EmailModal.scss";
import { MyNotif } from "../NotifIcons/NotifIcons";
import ProductServices from "../../actions/products-actions/services";

const { TextArea } = Input;

export interface IEmailModalProps {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
}

export default function EmailModal({
  isVisible,
  setIsVisible,
}: IEmailModalProps) {
  const [emailData, setEmailData] = useState({
    subject: "Request for Gold Client Status",
    message: "Hello,\n\nI would like to become a Gold client, how could I proceed?\n\nThank you.",
  });
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setIsVisible(false);
    setEmailData({ subject: "", message: "" });
  };

  const handleSend = async () => {
    if (!emailData.subject.trim() || !emailData.message.trim()) {
      message.error("Please fill in both subject and message fields");
      return;
    }

    setLoading(true);
    try {
      await ProductServices.sendContactEmail(emailData);
      
     MyNotif("Your message has been sent successfully!", "success");
      handleCancel();
    } catch (error) {
      MyNotif("Failed to send message. Please try again.", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Contact Our Team"
      visible={isVisible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="send"
          type="primary"
          loading={loading}
          onClick={handleSend}
        >
          Send Message
        </Button>,
      ]}
      wrapClassName="email_modal"
    >
      <div className="email_modal_content">
        <p className="email_modal_description">
          Send us a message to learn more about becoming a Gold client and
          gaining full access to all product information.
        </p>
        <div className="field">
          <Input
            placeholder="Subject"
            value={emailData.subject}
            onChange={(e) =>
              setEmailData({ ...emailData, subject: e.target.value })
            }
          />
        </div>
        <div className="field">
          <TextArea
            placeholder="Your message"
            rows={6}
            value={emailData.message}
            onChange={(e) =>
              setEmailData({ ...emailData, message: e.target.value })
            }
          />
        </div>
      </div>
    </Modal>
  );
}
